<template>
    <div id="main">
        <div class="page">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="vertical-flow">
                <HeaderProdutoGrupo 
                    :regraDesconto="regraDesconto" 
                    :isEditItems="isEditItems"
                    :itensSelecionados="isEditItems ? itensSelecionados : itensNovosSelecionados"
                    :isItemsSelecionados="isItemsSelecionados"
                    @fecharModal="onFecharModal"
                    @resetPagination="resetPagination"/>
                <div class="column is-12">
                    <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-campo-busca-forma-pagamento-descricao" />
                </div>
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="isEditItems ? itensSelecionados : itens"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    :checkable="!isEditItems"
                    :checked-rows.sync="itensNovosSelecionados"
                    :custom-is-checked="(selecionados, linha) => isEditItems 
                        ? (selecionados.idVenPoliticaDescontoItem === linha.idVenPoliticaDescontoItem) 
                        : selecionados.id === linha.id">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :visible="f.visible"
                        :custom-sort="f.sortFn"
                        v-slot="props">
                        <div>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    v-if="!isEditItems"
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ProdutoService from '@/services/vendas/produto/ProdutoService';
import GrupoProdutoService from '@/services/GrupoProdutoService';
import RegrasDescontoItemService from '@/services/RegrasDescontoItemService';
import Message from "@/models/Message";
import HeaderProdutoGrupo from '@/components/vendas/regras-desconto/header/HeaderProdutoGrupo';

export default {
    components: {
        Message,
        ContainerLoader,
        HeaderProdutoGrupo
    },
    props: {
        isItemsSelecionados: {
            type: Boolean,
            default: false,
        },
        isEditItems: {
            type: Boolean,
            default: false,
        },
        regraDesconto: {
            type: Object,
            default: {},
        },
        itensSelecionados: {
            type: Array,
            default: []
        },
    },
    data() {
        return {
            itens: [],
            itensNovosSelecionados: [],
            produtoService: new ProdutoService(this.$http, this.$router),
            grupoService: new GrupoProdutoService(this.$http, this.$router),
            serviceItemDesconto: new RegrasDescontoItemService(this.$http, this.$router),
            fields: [
                { key: 'codigo', sortable: true, sortFn: null, visible: true },
                { key: 'descricao', width: 800, sortable: true, sortFn: null, visible: true }
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            tipoRegraProdutoNovo: null,
            isLoading: false,
            isEmpty: true,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            msgs: [],
        };
    },
    created() {
        console.log(this.itensSelecionados)
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.tabPreco = {
            id: this.regraDesconto.tabelaPreco.id, 
            label: this.regraDesconto.tabelaPreco.descricao
        }
        
        this.tipoRegraProdutoNovo = this.regraDesconto && this.regraDesconto.tipoRegraProduto
            ? JSON.parse(JSON.stringify(this.regraDesconto.tipoRegraProduto))
            : { id: 0, label: 'por-produto' };

        if(this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ){
            this.carregarDadosProduto();
        } else {
            this.carregarDadosGrupo();
        }
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            if(this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ){
                this.carregarDadosProduto(value.currentPage);
            } else {
                this.carregarDadosGrupo(value.currentPage);
            }        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            if(this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ){
                this.carregarDadosProduto(value.currentPage);
            } else {
                this.carregarDadosGrupo(value.currentPage);
            }
        },
        resetPagination(regraProduto){
            this.tipoRegraProdutoNovo = regraProduto;
            this.itensNovosSelecionados = [];
            if(this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ){
                this.carregarDadosProduto();
            } else {
                this.carregarDadosGrupo();
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
        carregarDadosGrupo(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
                this.isLoading = true;
                const sort = {
                    column: this.column,
                    order: this.order
                }
            this.grupoService
                .findAllNaoVinculadoRegraDesconto(
                    currentPage - 1,
                    this.pagination.perPage,
                    sort,
                    this.regraDesconto.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.itens = value;
                    this.isEmpty = this.itens.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os grupos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        carregarDadosProduto(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
                this.isLoading = true;
                const sort = {
                    column: this.column,
                    order: this.order
                }
            this.produtoService
                .findAllNaoVinculadoRegraDesconto(
                    currentPage - 1,
                    this.pagination.perPage,
                    sort,
                    this.regraDesconto.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.itens = value;
                    this.isEmpty = this.itens.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os produtos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let list = [];
            if (body.content) {
                list = body.content.map((gp) => {
                    return {
                        id: this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ? gp.idproduto : gp.idgrupoproduto,
                        codigo: this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ? gp.idprodutoerp : gp.idgrupoprodutoerp,
                        descricao: gp.descricao,
                    };
                });
            }
            return list;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            if(this.tipoRegraProdutoNovo && this.tipoRegraProdutoNovo.id == 0 ){
                this.carregarDadosProduto();
            } else {
                this.carregarDadosGrupo();
            }        
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    background-color: $bg-color;
    border-radius: 5px;
    padding: 5px 20px;
    height: 100%;

    .page {
        padding-left: 0;
        .table-tag {
            width: 5rem !important;
        }
    }
}
</style>
